import { Theme, color, rem } from '@thiememeulenhoff/lit-sdk';
import { css, unsafeCSS } from 'lit';
import * as token from '@thiememeulenhoff/tokens/core';
import { tagName } from '../../../helpers';

export const tag = tagName('content-modal');
const theme = new Theme(tag);

export const styles = [
  css`
    :where(dialog) {
      ${theme.props([
        ['background', 'background', color('white')],
        ['border-radius', 'border-radius', rem(8)],
      ])};

      min-inline-size: ${rem(740)};

      @media (max-width: ${unsafeCSS(token.BreakpointSmall)}) {
        min-inline-size: 90vw;
      }
    }

    :where(container) {
      display: flex;
      flex-direction: column;
      gap: ${rem(12)};
      padding: ${rem(20)};
    }

    :where(header) {
      font-weight: bold;
    }

    :where(.loaderBackground) {
      background-color: ${color('white')};
      opacity: 0.9;
    }

    :where(.loading) {
      display: flex;
      justify-content: center;
    }

    :where(.loading, .loaderBackground) {
      block-size: 100%;
      inline-size: 100%;
      inset-block-start: 0;
      position: absolute;
    }
  `,
];
